// @ts-nocheck
import { Button } from "@mui/material";
import PropTypes from "prop-types";

export const CustomButton = (props) => {
  const primartStyle = {
    height: "60px",
    width: "50%",
    borderRadius: "12px",
    boxShadow: "0px 30px 80px 0px #FF00FF4D 0px 0px 20px 0px #00000099 inset",
    // boxShadow: "0px 0px 20px 0px #00000099 inset",
  };

  return (
    <Button onClick={props.onClick} sx={primartStyle}>
      {props.children}
    </Button>
  );
};

export const SecondaryButton = ({ onClick, children, isDisabled, width }) => {
  const secondaryStyle = {
    "&:hover": {
      backgroundColor: isDisabled ? "gray" : "#00BFCD",
      boxShadow: "0px 4px 20px 0px #009279 inset",
      cursor: isDisabled ? "not-allowed" : "pointer",
    },
    height: "60px",
    width: width ? width : "50%",
    borderRadius: "12px",
    backgroundColor: isDisabled ? "gray" : "#00BFCD",
    boxShadow: `0px 4px 20px 0px ${isDisabled ? "gray" : "#009279"} inset`,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  };

  return (
    <Button onClick={onClick} sx={secondaryStyle}>
      {children}
    </Button>
  );
};

SecondaryButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};